@if(strategyOptions.length){
<div class="strategy-home-page" [attr.dir]="dir">

  <!-- Page Header -->
  <header class="page-hero">
    <div class="page-hero__text">
      <p class="page-hero__eyebrow">{{ 'Home' | navTitle | async }}</p>
      <h1 class="page-hero__title">{{ selectedStrategy?.name || (dir === 'rtl' ? 'الاستراتيجية' : 'Strategy') }}</h1>
      <p class="page-hero__subtitle">
        {{ dir === 'rtl'
          ? 'نظرة سريعة على المحاور والأهداف والمبادرات، مع انتقال سريع لأقسام العمل.'
          : 'A quick overview of pillars, goals and initiatives, with fast access to key areas.' }}
      </p>
    </div>

    <div class="page-hero__controls">
      <label class="control-label">{{ dir === 'rtl' ? 'الاستراتيجية' : 'Strategy' }}</label>
      <p-dropdown
        [(ngModel)]="selectedStrategyId"
        [options]="strategyOptions"
        optionLabel="name"
        optionValue="strategyId"
        [placeholder]="dir === 'rtl' ? 'اختر الاستراتيجية' : 'Select strategy'"
        (onChange)="strategyOptionsChange()"
        styleClass="strategy-dropdown">
      </p-dropdown>
    </div>
  </header>

  <!-- Stats -->
  <section class="stats-section" aria-label="summary">
    <div class="stats-grid">
      <button type="button" class="stat-card" (click)="goTo('pillars')">
        <div class="stat-icon">
          <i class="fa-solid fa-layer-group"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'pillars'|translate}}</div>
          <div class="stat-value">{{getTotalPillarsCount()}}</div>
        </div>
        <span class="stat-action">{{ dir === 'rtl' ? 'عرض' : 'View' }} <i class="fa-solid fa-arrow-left"></i></span>
      </button>

      <button type="button" class="stat-card" (click)="goTo('goals')">
        <div class="stat-icon">
          <i class="fa-solid fa-bullseye"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'goals'|translate}}</div>
          <div class="stat-value">{{getTotalGoalsCount()}}</div>
        </div>
        <span class="stat-action">{{ dir === 'rtl' ? 'عرض' : 'View' }} <i class="fa-solid fa-arrow-left"></i></span>
      </button>

      <button type="button" class="stat-card" (click)="goTo('indicators')">
        <div class="stat-icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'indicators'|translate}}</div>
          <div class="stat-value">{{getTotalIndicatorsCount()}}</div>
        </div>
        <span class="stat-action">{{ dir === 'rtl' ? 'عرض' : 'View' }} <i class="fa-solid fa-arrow-left"></i></span>
      </button>

      <button type="button" class="stat-card" (click)="goTo('projects')">
        <div class="stat-icon">
          <i class="fa-solid fa-lightbulb"></i>
        </div>
        <div class="stat-content">
          <div class="stat-label">{{'projects'|translate}}</div>
          <div class="stat-value">{{getTotalProjectsCount()}}</div>
        </div>
        <span class="stat-action">{{ dir === 'rtl' ? 'عرض' : 'View' }} <i class="fa-solid fa-arrow-left"></i></span>
      </button>
    </div>
  </section>

  <!-- Quick Links -->
  <section class="quick-links" aria-label="quick links">
    <button type="button" class="quick-link" (click)="goTo('dashboard')">
      <i class="fa-solid fa-chart-pie"></i>
      <span>{{ dir === 'rtl' ? 'لوحة البيانات' : 'Dashboard' }}</span>
    </button>
    <button type="button" class="quick-link" (click)="goTo('performance')">
      <i class="fa-solid fa-gauge-high"></i>
      <span>{{ dir === 'rtl' ? 'الأداء' : 'Performance' }}</span>
    </button>
    <button type="button" class="quick-link" (click)="goTo('reports')">
      <i class="fa-solid fa-file-invoice"></i>
      <span>{{ 'Reports' | navTitle | async }}</span>
    </button>
    <button type="button" class="quick-link" (click)="goTo('alignment')">
      <i class="fa-solid fa-diagram-project"></i>
      <span>{{ dir === 'rtl' ? 'المواءمة' : 'Alignment' }}</span>
    </button>
  </section>

  <!-- Goals Overview -->
  <section class="overview-section">
    <div class="overview-card">
      <div class="overview-header">
        <div class="overview-heading">
          <h2 class="overview-title">{{ dir === 'rtl' ? 'أهداف المحور' : 'Pillar Goals' }}</h2>
          <p class="overview-hint">
            {{ dir === 'rtl'
              ? 'اختر محوراً لعرض أهدافه، ثم انتقل لتفاصيل الهدف.'
              : 'Pick a pillar to browse its goals, then open a goal for details.' }}
          </p>
        </div>
        <div class="pillar-selector">
          <p-dropdown
            [(ngModel)]="selectedPillar"
            [options]="alignmentStrategy?.pillars || []"
            optionLabel="name"
            dataKey="id"
            [placeholder]="dir === 'rtl' ? 'اختر المحور' : 'Select Pillar'"
            (onChange)="onPillarChange()"
            styleClass="pillar-dropdown">
          </p-dropdown>
        </div>
      </div>

      @if (alignmentStrategy?.pillars?.length) {
      <div class="pillar-chips" role="tablist">
        @for (pillar of alignmentStrategy.pillars; track pillar.id) {
          <button
            type="button"
            class="pillar-chip"
            [class.active]="selectedPillar?.id === pillar.id"
            (click)="selectPillarChip(pillar)">
            <span class="pillar-chip__name">{{ pillar.name }}</span>
            <span class="pillar-chip__count">{{ pillar.goals?.length || 0 }}</span>
          </button>
        }
      </div>
      }

      <div class="goals-grid">
        @if(selectedPillar && selectedPillar.goals?.length) {
          @for (goal of selectedPillar.goals; track goal.id; let i = $index) {
            <button type="button" class="goal-card" (click)="goToGoal(goal)">
              <div class="goal-header">
                <div class="goal-badge">{{ i + 1 }}</div>
                <div class="goal-copy">
                  <h3 class="goal-title">{{ goal.name }}</h3>
                  @if (goal.code) {
                    <span class="goal-code">{{ goal.code }}</span>
                  }
                </div>
              </div>
              <div class="goal-footer">
                <span class="goal-tag">
                  <i class="fa-solid fa-chart-simple"></i>
                  {{ goal.no_indicators || 0 }} {{'indicators'|translate}}
                </span>
                <span class="goal-open">
                  {{ dir === 'rtl' ? 'فتح' : 'Open' }}
                  <i class="fa-solid fa-arrow-left"></i>
                </span>
              </div>
            </button>
          }
        } @else {
          <div class="empty-state">
            <div class="empty-state__icon">
              <i class="pi pi-inbox"></i>
            </div>
            <p class="empty-state__title">
              {{ dir === 'rtl' ? 'لا توجد أهداف لهذا المحور' : 'No goals for this pillar' }}
            </p>
            <p class="empty-state__text">
              {{ dir === 'rtl' ? 'اختر محوراً آخر أو أضف أهدافاً من صفحة الأهداف.' : 'Select another pillar or add goals from the goals page.' }}
            </p>
            <button type="button" class="empty-state__btn" (click)="goTo('goals')">
              {{ dir === 'rtl' ? 'الذهاب للأهداف' : 'Go to goals' }}
            </button>
          </div>
        }
      </div>
    </div>
  </section>

</div>
}
